<div>
  <app-re-use-targets-filters (search)="searchData($event)">
  </app-re-use-targets-filters>
  <mat-divider></mat-divider>
  <app-re-use-targets-map-chart *ngIf="data"
                                [title]="text"
                                [subtitle]="subtitle"
                                [data]="data">
  </app-re-use-targets-map-chart>
</div>
